module.exports = __webpack_public_path__ + "img/imoney.5cbf1d07.png";